/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  ADD_POST_APPROVAL_EVENT,
  REMOVE_POST_APPROVAL_EVENT,
  SET_INITIAL_POST_APPROVAL_EVENTS
} from 'src/actions/digitalDispatchPostApprovalEventNotificationActions';

const initialState = {
  digitalDispatchPostApprovalEventsThatRequireResponse: null
};

/**
 * Utility method to remove any duplicate entries in the post approval
 * event notifications array
 * @param {Object[]} sourceArray
 * @returns {Object[]}
 */
const removeDuplicatesFromArray = (sourceArray) => {
  if (!sourceArray?.length) return sourceArray;
  const uniqueSet = new Set();
  return sourceArray.filter(({ id }) => {
    const isDuplicate = uniqueSet.has(id);
    uniqueSet.add(id);
    return !isDuplicate;
  });
};

/**
 * Sorts the Objects based on the DateCreated field so the
 * most recent notification is rendered at the top of the list
 * @param {Object[]} sourceArray
 * @returns {Object[]}
 */
const sortItemsByDateCreated = (sourceArray) => {
  if (!sourceArray?.length) return sourceArray;
  return sourceArray
    .sort((
      { dateCreated: dateCreatedA },
      { dateCreated: dateCreatedB }
    ) => new Date(dateCreatedB) - new Date(dateCreatedA));
};

// eslint-disable-next-line default-param-last
const digitalDispatchPostApprovalEventNotificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_POST_APPROVAL_EVENT: {
      const newPostApprovalEvent = action.payload?.newPostApprovalEvent;
      return produce(state, (draft) => {
        const combinedNotificationsArray = [
          ...state.digitalDispatchPostApprovalEventsThatRequireResponse,
          newPostApprovalEvent
        ];
        const duplicatesRemovedNotificationsArray = removeDuplicatesFromArray(
          combinedNotificationsArray
        );
        const mostRecentNotificationsFirstArray = sortItemsByDateCreated(
          duplicatesRemovedNotificationsArray
        );
        draft.digitalDispatchPostApprovalEventsThatRequireResponse = mostRecentNotificationsFirstArray;
      });
    }
    case REMOVE_POST_APPROVAL_EVENT: {
      const postApprovalEventIdToRemove = action.payload?.answeredPostApprovalEventId;
      return produce(state, (draft) => {
        const notificationsWithReadNotificationRemoved = state
          .digitalDispatchPostApprovalEventsThatRequireResponse
          ?.filter(({ id }) => id !== postApprovalEventIdToRemove);
        draft
          .digitalDispatchPostApprovalEventsThatRequireResponse = notificationsWithReadNotificationRemoved;
      });
    }

    case SET_INITIAL_POST_APPROVAL_EVENTS: {
      const initialRecords = action.payload?.initialPostApprovalEvents;
      return produce(state, (draft) => {
        draft.digitalDispatchPostApprovalEventsThatRequireResponse = initialRecords;
      });
    }
    default: {
      return state;
    }
  }
};

export default digitalDispatchPostApprovalEventNotificationReducer;
